import TicketApi from "../api/ticket";

const CREATING_TICKET = "CREATING_TICKET",
    CREATING_TICKET_SUCCESS = "CREATING_TICKET_SUCCESS",
    CREATING_TICKET_ERROR = "CREATING_TICKET_ERROR",
    ANSWERING_TICKET = "ANSWERING_TICKET",
    ANSWERING_TICKET_SUCCESS = "ANSWERING_TICKET_SUCCESS",
    ANSWERING_TICKET_ERROR = "ANSWERING_TICKET_ERROR",
    FETCHING_TICKETS = "FETCHING_TICKETS",
    FETCHING_TICKETS_SUCCESS = "FETCHING_TICKETS_SUCCESS",
    FETCHING_TICKETS_ERROR = "FETCHING_TICKETS_ERROR",
    FETCHING_THREAD = "FETCHING_THREAD",
    FETCHING_THREAD_SUCCESS = "FETCHING_THREAD_SUCCESS",
    FETCHING_THREAD_ERROR = "FETCHING_THREAD_ERROR",
    CLOSING_TICKET = "CLOSING_TICKET",
    CLOSING_TICKET_SUCCESS = "CLOSING_TICKET_SUCCESS",
    CLOSING_TICKET_ERROR = "CLOSING_TICKET_ERROR";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        entities: [],
        parent: null,
        attachments: [],
        messages: [],
        total_rows: 0
    },
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        hasError(state) {
            return state.error !== null;
        },
        error(state) {
            return state.error;
        },
        hasTickets(state) {
            return state.entities.length > 0;
        },
        tickets(state) {
            return state.entities;
        },
        parent(state){
            return state.parent;
        },
        attachments(state) {
            return state.attachments;
        },
        messages(state) {
            return state.messages;
        }
    },
    mutations: {
        [CREATING_TICKET](state) {
            state.isLoading = true;
            state.error = null;
        },
        [CREATING_TICKET_SUCCESS](state, entity) {
            state.isLoading = false;
            state.error = null;
        },
        [CREATING_TICKET_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [ANSWERING_TICKET](state) {
            state.isLoading = true;
            state.error = null;
        },
        [ANSWERING_TICKET_SUCCESS](state, entity) {
            state.isLoading = false;
            state.error = null;
        },
        [ANSWERING_TICKET_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [FETCHING_TICKETS](state) {
            state.isLoading = true;
            state.error = null;
            state.entities = [];
        },
        [FETCHING_TICKETS_SUCCESS](state, entities) {
            state.isLoading = false;
            state.error = null;
            state.entities = entities;
        },
        [FETCHING_TICKETS_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.entities = [];
        },
        [FETCHING_THREAD](state) {
            state.isLoading = true;
            state.error = null;
            state.attachments = [];
            state.messages = [];
        },
        [FETCHING_THREAD_SUCCESS](state, entities) {
            
            state.error = null;
            state.thread = entities;
            for (let i = 0; i < entities.length; i++) {
                if (entities[i].ticket_file) {
                    state.attachments.push(entities[i]);
                }
                if (entities[i].ticket_answer || entities[i].ticket_question){
                    state.messages.push(entities[i]);
                }
                if (i == 0){
                    state.parent = entities[i];
                }
            }
            state.isLoading = false;
        },
        [FETCHING_THREAD_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.thread = [];
        },
        [CLOSING_TICKET](state) {
            state.isLoading = true;
            state.error = null;
        },
        [CLOSING_TICKET_SUCCESS](state, entity) {
            state.isLoading = false;
            state.error = null;
        },
        [CLOSING_TICKET_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
        },
    },
    actions: {
        async findAll({ commit }, ctx) {
            commit(FETCHING_TICKETS);
            try {
                let response = await TicketApi.findAll(ctx);
                commit(FETCHING_TICKETS_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(FETCHING_TICKETS_ERROR, error);
                return null;
            }
        },
        async create({ commit }, params) {
            commit(CREATING_TICKET);
            try {
                let response = await TicketApi.create(params);
                commit(CREATING_TICKET_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(CREATING_TICKET_ERROR, error);
                return null;
            }
        },
        async answer({ commit }, ticket) {
            commit(ANSWERING_TICKET);
            try {
                let response = await TicketApi.answer(ticket);
                commit(ANSWERING_TICKET_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(ANSWERING_TICKET_ERROR, error);
                return null;
            }
        },
        async thread({ commit }, params) {
            commit(FETCHING_THREAD);
            try {
                let response = await TicketApi.thread(params);
                commit(FETCHING_THREAD_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(FETCHING_THREAD_ERROR, error);
                return null;
            }
        },
        async close({commit},params){
            commit(CLOSING_TICKET);
            try {
                let response = await TicketApi.close(params);
                commit(CLOSING_TICKET_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(CLOSING_TICKET_ERROR, error);
                return null;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/ticket.js